<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <!-- <span
        class="d-flex justify-content-between align-items-center pb-2 mb-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">Email PDF</h2>
        </span>
        <div class="col-auto">
          <i class="pi pi-times"></i>
        </div>
      </span> -->

      <ng-container [formGroup]="parent">
        <ng-container formGroupName="header">
          <div class="row">
            <div class="col-3 col-min-12">
              <div class="form-group has-float-label mt-2">
                <label class="form-label">Template Name</label>
                <p-select
                  formControlName="templateId"
                  (onChange)="onTemplateSelection($event)"
                  [options]="templates"
                  optionLabel="name"
                  optionValue="id"
                  [showClear]="true"
                  [filter]="true">
                </p-select>
              </div>
            </div>
            <div class="col-3 col-min-12" *ngIf="displaySaleOrderSection">
              <div class="form-group has-float-label mt-2">
                <label class="form-label">Sale Order Id</label>
                <input
                  pInputText
                  class="form-control"
                  type="text"
                  formControlName="saleOrderId" />
              </div>
            </div>

            <div class="col-3 col-min-12" *ngIf="displayPoSection">
              <div class="form-group has-float-label mt-2">
                <label class="form-label">PO #</label>
                <input
                  pInputText
                  class="form-control"
                  type="text"
                  formControlName="poNumber" />
              </div>
            </div>

            <div class="col d-flex">
              <div
                class="d-flex col align-items-center justify-content-between">
                <div class="d-flex gap-3">
                  <div
                    class="d-flex gap-2 d-flex align-items-center"
                    *ngIf="displayRushRevisedSection">
                    <p-checkbox
                      id="firm1"
                      [binary]="true"
                      formControlName="rush"
                      (click)="onRushSelection($event)" />
                    <label class="mt-1">Rush</label>

                    <!-- <label class="d-block form-check-label mb-1">Rush</label>
          <input
            pInputText
            class="form-check-input m-0 no-bg"
            type="checkbox"
            id="firm1"
            formControlName="rush"
            (click)="onRushSelection($event)" /> -->
                  </div>
                  <div
                    class="d-flex gap-2 d-flex align-items-center"
                    *ngIf="displayRushRevisedSection">
                    <p-checkbox
                      id="firm1"
                      [binary]="true"
                      formControlName="revised"
                      (click)="onRevisedSelection($event)" />
                    <label class="mt-1">Revised</label>

                    <!-- <label class="d-block form-check-label mb-1">Revised</label>
          <input
            pInputText
            class="form-check-input m-0 no-bg"
            type="checkbox"
            id="firm1"
            formControlName="revised"
            (click)="onRevisedSelection($event)" /> -->
                  </div>
                </div>
                <div>
                  <p-button
                    label="Email"
                    *ngIf="!!poJournalPdf"
                    (click)="onEmailSelection()"
                    [outlined]="true"
                    severity="secondary" />

                  <!-- <a
              class="has-link"
              *ngIf="!!poJournalPdf"
              (click)="onEmailSelection()"
              >Email</a
            > -->
                </div>
              </div>
            </div>
          </div>
          <div>
            <ngx-extended-pdf-viewer
              [base64Src]="poJournalPdf"
              [textLayer]="true"
              [showHandToolButton]="true"
              [showPresentationModeButton]="true"
              [filenameForDownload]="
                displayPoSection
                  ? 'Nadel-PO# ' + poNumber
                  : getFileNameByModuleState()
              "
              height="75vh"></ngx-extended-pdf-viewer>
          </div>
        </ng-container>
      </ng-container>
    </p-card>
  </div>
</div>
